import { BindingEngine, autoinject, bindable, bindingMode, customElement } from 'aurelia-framework';
import { ValidateResult } from 'aurelia-validation';
import { Router, activationStrategy } from 'aurelia-router';
import { BaseView } from 'Common/BaseView';
import { DataService } from 'DataAccessLayer/Services/DataService';
import { I18N } from 'aurelia-i18n';
import { PromptController } from 'Code/Prompts/PromptController';
import { ValidationHelper } from 'Code/Helpers/ValidationHelper';
import { AuthService } from 'DataAccessLayer/Services/AuthService';
import { GuidHelper } from 'Code/Helpers/GuidHelper';

@autoinject
export class EditBaseView extends BaseView {

    @bindable({ defaultBindingMode: bindingMode.toView }) entityId: number = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) entityName: string = null;
    @bindable({ defaultBindingMode: bindingMode.twoWay }) entityData: Object = null;

    protected dataService: DataService = null;
    private _authService: AuthService = null;
    protected promptController: PromptController = null;
    protected i18n: I18N = null;
    protected router: Router = null;
    protected validationHelper: ValidationHelper = null;
    protected routeConfig: any = null;

    constructor(dataService: DataService, router: Router, validationHelper: ValidationHelper, promptController: PromptController, i18n: I18N, authService: AuthService) {
        super();
        
        this.dataService = dataService;
        this.router = router;
        this.validationHelper = validationHelper;
        this.promptController = promptController;
        this.i18n = i18n;
        this._authService = authService;

    }

    activate(params, routeConfig, $navigationInstruction) {
        this.entityId = params.entityId;
        this.entityName = params.entityName;
        this.routeConfig = routeConfig;
    }

    async bind() {
        
    }

    attached() {
    }

}
